import { useState, useEffect } from "react";
import { IoChevronDown, IoChevronUp, IoClose, IoReload } from "react-icons/io5";
import { useParams } from "react-router-dom";
import CodeTreeLoader from "../Loaders/CodeTreeLoader";
import { TbLogs } from "react-icons/tb";
import Spinner from "../Components/Spinner";
import FormatDateTime from "../Functions/FormatDate";
import { BsThreeDots } from "react-icons/bs";
import { useLanguage } from "../Translations/LenguageContext";

const EditorTerminal = ({
    openTerminal,
    setOpenTerminal,
    fetchMcpLogs,
    logLoading,
    statusMcp,
    mcpData,
    mcpLogs,
    loadingSave
}) => {
    const {t} = useLanguage()
    const { mcp_id } = useParams()
    const [openLog, setOpenLog] = useState("")
    const [terminalHeight, setTerminalHeight] = useState(180);
    const [isDragging, setIsDragging] = useState(false);

    const toggleTerminal = () => {
        if (openTerminal) {
            setOpenTerminal(false)
            setOpenLog("")
        } else {
            setOpenTerminal(true)
        }
    }

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (!isDragging) return;

            const newHeight = window.innerHeight - e.clientY;

            const clampedHeight = Math.max(0, Math.min(500, newHeight));

            setTerminalHeight(clampedHeight);
        };

        const handleMouseUp = () => {
            setIsDragging(false);
        };

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mouseup", handleMouseUp);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [isDragging]);

    return (
        <div className="editor_terminal">
            {openTerminal && (
                <button
                    className="terminal_cont_drag_btn"
                    onMouseDown={() => setIsDragging(true)}
                >
                    <BsThreeDots />
                </button>
            )}
            <div className="editor_terminal_header">
                <p>
                    <TbLogs />
                    {t.abilities.ability_logs}
                </p>
                <div className="editor_terminal_header_btn_cont">

                    <button onClick={fetchMcpLogs} className="main_mcp_cont_chat_btn">{logLoading ? <Spinner loading={true} /> : <IoReload />}</button>
                    <button className="main_mcp_cont_chat_btn" onClick={toggleTerminal}>
                        {openTerminal ? <IoClose /> : <IoChevronUp />}
                    </button>
                </div>
            </div>
            <div
                className={`terminal_cont ${openTerminal ? "" : "terminal_cont_closed"}`}
                style={
                    {
                        height: openTerminal ? `${terminalHeight}px` : "0px",
                    }

                }
            >
                {/* {logLoading || statusMcp == "LOADING" ? (
                    <div className="terminal_cont_item_container">
                        <CodeTreeLoader />
                    </div>
                ) : ( */}
                    <div className="terminal_cont_item_container">
                        {loadingSave && (
                            <div className="terminal_cont_item">
                                <div className="terminal_cont_item_header">
                                        <button
                                            className="terminal_cont_item_btn"
                                        >
                                            <Spinner loading={true} />
                                        </button>
                                    <p className="log_message fade-in">
                                        {t.abilities.saving_sm} <strong>{mcpData.mcp_name}</strong> - {mcp_id}
                                    </p>
                                </div>
                            </div>
                        )}

                        {statusMcp == "DEPLOYING" && mcpData.mcp_name && (
                            <div className="terminal_cont_item">
                                <div className="terminal_cont_item_header">
                                        <button
                                            className="terminal_cont_item_btn"
                                        >
                                            <Spinner loading={true} />
                                        </button>
                                    <p className="log_message fade-in">
                                        {t.abilities.publishing} <strong>{mcpData.mcp_name} - {mcp_id}</strong>. {t.abilities.few_minutes}
                                    </p>
                                </div>
                            </div>
                        )}
                        {mcpLogs.length > 0 ? (
                            mcpLogs.map((log) => (
                                <div key={log.id} className="terminal_cont_item">
                                    <div className="terminal_cont_item_header">
                                        <button
                                            className="terminal_cont_item_btn"
                                            onClick={() =>
                                                setOpenLog(openLog === log.id ? null : log.id)
                                            }
                                        >
                                            {openLog === log.id ? (
                                                <IoChevronUp />
                                            ) : (
                                                <IoChevronDown />
                                            )}
                                        </button>
                                        <p className={`log_message fade-in ${log.severity == 2 ? "log_message_red" : ""}`}><span>{FormatDateTime(log.created_at)}</span>

                                            {log.severity != 2 ? (
                                                <> - {log.message}</>
                                            ) : (
                                                <> - {t.error_occurred}</>
                                            )

                                            } </p>
                                    </div>

                                    <div
                                        className={`terminal_cont_item_cont ${openLog === log.id ? "terminal_cont_item_cont_open" : ""
                                            } ${openLog === log.id && log.severity == 2 ? "terminal_cont_item_cont_red" : ""}`}
                                    >
                                        <pre>
                                            {JSON.stringify(
                                                {
                                                    ...(log || {}),
                                                    created_at: log?.created_at
                                                        ? FormatDateTime(log.created_at)
                                                        : log?.created_at
                                                },
                                                null,
                                                2
                                            )}
                                        </pre>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="terminal_cont_item_container">
                                <div className="no_log_terminal_cont_item">
                                    {t.no_logs}
                                </div>
                            </div>
                        )}
                    </div>

                {/* )} */}
            </div>
        </div>
    )
}

export default EditorTerminal